import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import Icon from '../Icon/icon';
import { noop } from '../../../../lib/utilities';
export class LightBox extends React.Component {
    componentDidMount() {
        this._elements = {
            content: $(this.refs.content),
            lightbox: $(this.refs.lightbox),
            container: $(this.refs.container)
        };
        if (!this.props.disableCloseOnWindow) {
            this._elements.lightbox.on('mousedown', this.onCloseClick.bind(this));
        }
        if (!this.props.hideScroll) {
            this.applyScrollbar();
            $(window).on('resize', this.applyScrollbar.bind(this));
        }



        this.componentDidUpdate({ opened: false });
        this.onBackClick = this.onBackClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { opened } = this.props;

        if (opened !== prevProps.opened) {
            if (opened) {
                LightBox.fixBody();
            } else {
                LightBox.unfixBody();
            }
        }
    }

    onCloseButton(e) {
        e.stopPropagation();
    }

    render() {
        const additionalClassNames = this.props.additionalClassNames || [];
        const classNames = ['lightbox', ...additionalClassNames];
        const { headerIcon, bannerText } = this.props;

        if (this.props.activePage !== '') {
            classNames.push('lightbox--active-page-' + this.props.activePage);
        }

        if (this.props.opened) {
            classNames.push('lightbox--visible');
        }

        return (
            <div ref="lightbox" className={classNames.join(' ')}>
                <div className="lightbox__underlay" />
                <div ref="container" className="lightbox__container">
                    {
                        headerIcon && <Icon headerIcon iconName={headerIcon} />
                    }
                    <span style={{ display: !this.props.hideCloseButton ? 'block' : 'none' }} className="lightbox__close" onClick={this.props.onClose}><Icon iconName="icon--close" /></span>
                    <div className="lightbox__content" ref="content">
                        {this.props.showBackButton && <span onClick={() => this.onBackClick()} className="lightbox__back"><Icon iconName="icon--back" /></span>}
                        {bannerText && <span className="banner-text">{bannerText}</span>}
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }



    onCloseClick(e) {
        if (!$(e.target).isElementInside($(this.refs.container))) {
            this.props.onClose();
        }
    }

    onBackClick() {
        if (this.props) {
            this.props.onBack();
        }
    }

    static fixBody() {
        $(document.body).addClass('prevent-scroll');
    }

    static unfixBody() {
        $(document.body).removeClass('prevent-scroll');
    }

    applyScrollbar() {
        this._elements.content.scrollbar();
    }
}

LightBox.propTypes = {
    opened: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onBack: PropTypes.func,
    additionalClassNames: PropTypes.array,
    activePage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hideCloseButton: PropTypes.bool,
    showBackButton: PropTypes.bool,
    headerIcon: PropTypes.string,
    hideScroll: PropTypes.bool,
    disableCloseOnWindow: PropTypes.bool.isRequired

};

LightBox.defaultProps = {
    additionalClassNames: [],
    activePage: '',
    hideCloseButton: false,
    onBack: noop,
    showBackButton: false,
    hideScroll: false,
    disableCloseOnWindow: false,
};

export default LightBox;
